import {
  UserEmploymentData,
  UserProfileInformationData,
  UserSafeguardingData,
  UserSafeguardingRecordsData,
  UserTraningRecordsData,
} from '../../utils/types'
import { BASE_URL } from '../endpoints'
import { patch, post } from '../https'

export const updateUserProfile = (
  data: UserProfileInformationData,
  school: string,
  userId: string | undefined
): Promise<unknown> => {
  return patch(
    `${BASE_URL}/single-central-records/${userId}/profile?school=${school}`,
    data,
    null
  )
}

export const updateUserEmployment = (
  data: UserEmploymentData,
  school: string,
  userId: string | undefined
): Promise<unknown> => {
  return patch(
    `${BASE_URL}/single-central-records/${userId}/employment-details?school=${school}`,
    data,
    null
  )
}

export const updateUserSafeguarding = (
  data: UserSafeguardingData,
  school: string,
  userId: string | undefined
): Promise<unknown> => {
  return patch(
    `${BASE_URL}/single-central-records/${userId}/safeguarding-records?school=${school}`,
    data,
    null
  )
}

export const AddUserTrainingRecords = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: UserTraningRecordsData,
  schoolId: string,
  userId: string | undefined
): Promise<unknown> => {
  return post(
    `${BASE_URL}/single-central-records/${userId}/training-records?school=${schoolId}`,
    data,
    null
  )
}

export const updateUserTrainingRecords = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: UserTraningRecordsData,
  schoolId: string,
  userId: string | undefined
): Promise<unknown> => {
  return patch(
    `${BASE_URL}/single-central-records/${userId}/training-records?school=${schoolId}`,
    data,
    null
  )
}

export const updateUserSafeguardingRecords = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: UserSafeguardingRecordsData,
  schoolId: string,
  userId: string | undefined
): Promise<unknown> => {
  return patch(
    `${BASE_URL}/single-central-records/${userId}/safeguarding-records?school=${schoolId}`,
    data,
    null
  )
}
